<template>
	<div style="display: inline-block;">
		<Input type="text" v-model="scanCodeId" placeholder="使用扫码枪或手动输入" @keydown.enter.native="scanDownFunc"
			@keyup.enter.native="scanUpFunc" icon="md-qr-scanner" style="width:200px;" />
		<!-- 使用封装的自定义抽屉组件 -->
		<CustomDrawer v-model="selectedSKU" :title="`选择单品`" :width="700" placement="right" :mask="true"
			:mask-closable="true" :closable="true">
			<template #title>
				<div class="drawer-title">
					<div class="drawer-title-left">
						<Icon type="ios-search" :size='18' />
						选择单品
					</div>
					<div class="drawer-title-right"></div>
				</div>
			</template>
			<div class="drawer-content">
				<Table :key="tableKey" :height='pageHeight' disabled-hover :columns="skuColumn"
					:data="currentCommodity.data">
				</Table>
			</div>
			<template #footer>
				<div class="selected-sku">
					<Icon type="md-cart" size='20' />
					<Badge :count="getCurrentCommodityQuantity">
						<span>合计:&nbsp;¥{{getCurrentCommodityAmount}}</span>
					</Badge>
				</div>
				<button class="jxyd-button" @click="selectedSKU = false" style="margin-right: 10px;">取消</button>
				<button class="jxyd-button jxyd-primary" type="primary" @click="saveSelectedSKU">确定</button>
			</template>
		</CustomDrawer>
		<!-- 使用封装的图片预览子组件 -->
		<ImagePreview ref="imagePreview" :images="previewImagesList" :visible.sync="previewVisible"
			:initial-index="currentImageIndex" @change="onPreviewImageChange" />
	</div>
</template>

<script>
	import request from '@/utils/request'
	import ImagePreview from '@/components/ImagePreview' // 导入图片预览子组件
	import CustomDrawer from '@/components/CustomDrawer' // 导入自定义抽屉组件
	import formatNum from '@/utils/formatNum'
	export default {
		components: {
			ImagePreview,
			CustomDrawer
		},
		props: {
			commoditySelected: {
				type: Array,
				default: () => []
			},
			type: {
				type: String,
				default: '0'
			}
		},
		created: function() {
			this.$nextTick(() => {
				let contentElement = document.querySelector(".main-content");
				this.pageHeight = contentElement ? contentElement.offsetHeight - 120 : 700;
			})
		},
		computed: {
			isMultipleLines() {
				const seen = new Set();
				let units = [];
				if (this.currentCommodity && this.currentCommodity.commodity.id) {
					let array = this.commoditySelected.filter(m => m.commodity.id == this.currentCommodity.commodity.id);
					return array.some(item => {
						if (seen.has(item.commodity.id)) {
							return true;
						}
						for (let i = 0; i < item.data.length; i++) {
							if (units.length > 0 && units.indexOf(item.data[i].unit) <= -1) {
								return true;
							}
							units.push(item.data[i].unit);
						}
						seen.add(item.commodity.id);
						return false;
					});
				} else {
					return false;
				}
			},

			getCurrentUseUnit() {
				const commodity = this.currentCommodity.commodity
				return commodity.extraUnits.find(unit => unit.unit === commodity.unit) || null
			},

			getCurrentCommodityAmount() {
				if (!this.currentCommodity.data.length) return formatNum(0)

				const sumAmount = this.currentCommodity.data.reduce((sum, item) => {
					let price = 0
					if (['0', '1'].includes(this.type)) {
						price = item.intoPrice || 0
					} else if (['2', '3'].includes(this.type)) {
						price = item.retailPrice || 0
					}
					return sum + (item.quantity * price)
				}, 0)

				return formatNum(sumAmount)
			},

			getCurrentCommodityQuantity() {
				if (!this.currentCommodity.data.length) return formatNum(0)

				const sumQuantity = this.currentCommodity.data.reduce(
					(sum, item) => sum + (item.quantity || 0), 0
				)
				return formatNum(sumQuantity)
			},

			formatUnitSelectData() {
				const extraUnits = this.currentCommodity.commodity.extraUnits
				if (!extraUnits.length) return []

				return extraUnits.map(unit => ({
					value: unit.unit,
					text: unit.unit
				}))
			}
		},
		data() {
			return {
				currentCommodity: {
					commodity: this.getDefaultCommodity(),
					data: []
				},
				tableKey: 0,
				scanCodeId: '',
				enterDownTime: '',
				enterUpTime: '',
				skuColumn: [{
						title: '商品图片',
						key: 'imgFiles',
						width: 100,
						render: (h, params) => {
							return [h('div', {
								style: {
									'width': '40px',
									'height': '40px',
									'cursor': 'pointer'
								},
								on: {
									click: (val) => {
										this.previewSkuImages(params.row.imgFiles);
									}
								}
							}, [h('Avatar', {
								style: {
									'width': '100%',
									'height': '100%',
								},
								attrs: {
									'src': params.row.imgFiles.length > 0 ? params.row
										.imgFiles[
											0]
										.url :
										'/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
								}
							})])];
						}
					},
					{
						title: '商品',
						key: 'name',
						width: 150,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: this.currentCommodity.commodity.id
											}
										});
									}
								}
							}, this.currentCommodity.commodity.name);
						}
					},
					{
						title: '规格',
						key: 'priceType',
						width: 180,
						fixed: 'left'
					},
					{
						title: '数量',
						key: 'quantity',
						align: 'left',
						width: 120,
						render: (h, params) => {
							const stock = this.getCurrentCommodityTypeMaxStock(params.row);
							const allowNegativeStock = this.currentCommodity.commodity.negativeStock;

							// 使用统一方法获取最大值
							const maxValue = this.getMaxQuantity(stock, allowNegativeStock);
							return h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity,
									'max': maxValue,
									'placeholder': "请输入数量"
								},
								style: {
									'width': '100%'
								},
								on: {
									'input': (val2) => {
										this.currentCommodity.data[params.index].quantity = val2;
									}
								}
							});
						}
					},
					{
						title: '单位',
						key: 'unit',
						width: 100,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (val) => {
											this.currentCommodity.data[params.index].unit = val;
											const allowNegativeStock = this.currentCommodity.commodity
												.negativeStock;
											// 只有需要检查库存且不允许负库存时才限制
											if (this.shouldLimitMaxQuantity(allowNegativeStock)) {
												let maxStock = this.getCurrentCommodityTypeMaxStock(
													this.currentCommodity.data[params.index]);
												if (this.currentCommodity.data[params.index].quantity >
													maxStock) {
													this.currentCommodity.data[params.index].quantity =
														maxStock;
												}
											}
										}
									},
								},
								this.currentCommodity.commodity.extraUnits.map(function(type) {
									return h('Option', {
										props: {
											value: type.unit,
											key: type.unit
										}
									}, type.unit);
								})
							)];
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 120,
						render: (h, params) => {
							return h('label', {}, this.getCurrentCommodityTypeMaxStock(params.row));
						}
					},
					{
						title: '采购价',
						key: 'intoPrice',
						width: 120,
						render: (h, params) => {
							let unitData = this.getUnitData(params.row.unit);
							let price = params.row.intoPrice;
							if (unitData) {
								price = formatNum(price / unitData.conversionRate);
							}
							return h('span', {}, price + '元');
						}
					},
					{
						title: '零售价',
						key: 'retailPrice',
						width: 120,
						render: (h, params) => {
							let unitData = this.getUnitData(params.row.unit);
							let price = params.row.retailPrice;
							if (unitData) {
								price = formatNum(price / unitData.conversionRate);
							}
							return h('span', {}, price + '元');
						}
					},
					{
						title: '批发价',
						key: 'wholesalePricePrice',
						width: 120,
						render: (h, params) => {
							let unitData = this.getUnitData(params.row.unit);
							let price = params.row.wholesalePricePrice;
							if (unitData) {
								price = formatNum(price / unitData.conversionRate);
							}
							return h('span', {}, price + '元');
						}
					}
				],
				selectedSKU: false,
				// 图片预览相关 - 简化后的变量
				previewVisible: false,
				previewImagesList: [],
				currentImageIndex: 0,
				pageHeight: 0,
			}
		},
		methods: {
			saveSelectedSKU() {
				if (!this.currentCommodity.commodity) {
					this.showError('商品数据异常')
					return
				}

				const data = JSON.parse(JSON.stringify(this.currentCommodity));
				if (this.isMultipleLines) {
					this.commoditySelected.push(data);
				} else {
					const index = this.commoditySelected.findIndex(m => m.commodity.id == this.currentCommodity
						.commodity.id);
					if ((index || index == 0) && index > -1) {
						this.$set(this.commoditySelected, index, data)
					} else {
						this.commoditySelected.push(data);
					}
				}
				this.cleanupEmptyCommodities();
				this.$emit('submitSelected', this.commoditySelected);
				this.selectedSKU = false;
			},
			getDefaultCommodity() {
				return {
					id: 0,
					code: '',
					name: '',
					imgFile: [],
					type: '',
					unit: '',
					format: '',
					intoPrice: '',
					wholesalePricePrice: '',
					retailPrice: '',
					enableBatch: false,
					stockPrompt: '',
					isMultiMetering: false,
					extraUnits: [],
					isDifferentPricing: false,
					stock: '',
					commodityInventorys: [],
					commodityPriceTypeGroups: [],
					note: '',
					creator: 0,
					isUse: true
				}
			},

			case1IsExist(commodityData) {
				return this.commoditySelected.some(
					item => item.commodity.id === commodityData.id
				)
			},
			scanDownFunc() {
				this.enterDownTime = new Date().getTime();
			},
			async scanUpFunc() {
				this.enterUpTime = new Date().getTime();
				if (this.enterUpTime - this.enterDownTime < 30) {
					await this.selectCommodityByScanCode(this.scanCodeId);
					this.scanCodeId = '';
				} else {
					this.$emit('onInputVal', this.scanCodeId);
					this.$refs.selectCommodityModal.searchItems.searchVal = this.scanCodeId;
					this.$refs.selectCommodityModal.openSelectCommodityModal();
					this.scanCodeId = '';
				}
			},
			async selectCommodityByScanCode(code) {
				try {
					let result = await request.get('api/Commodity/GetCommodityByCode', {
						params: {
							code: code
						}
					});
					if (result.state !== 1 || !result.data) {
						result = await request.get('api/Commodity/GetCommodityPriceType', {
							params: {
								priceTypeCode: code
							}
						});
						if (result.state !== 1 || !result.data) {
							this.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "未找到商品或规格"
							});
							return
						}
						var data = this.commoditySelected.find(m => m.commodity.id == result.data.item1
							.commodityPriceTypeGroup.commodityId);
						if (data) {
							let stock = result.data.item1
								.commodityPriceTypeGroup.commodity.commodityInventorys
								.filter(m => m.commodityPriceType == result.data.item1.priceType)
								.reduce((sum, m) => sum + m.stock, 0);
							let priceType = data.data.find(m => m.priceType == result.data.item1
								.commodityPriceTypeGroup.groupName + ',' + result.data.item1.priceType);
							const newQuantity = priceType.quantity + 1;
							priceType.quantity = this.calculateStep(stock, newQuantity);
						} else {
							this.addNewCommodity2(result.data.item1, result.data.item2);
						}
						this.$emit('submitSelected', this.commoditySelected);
						return
					}

					this.handleScanResult(result.data)

				} catch (error) {
					console.error('扫码错误:', error)
					this.showError('请重新扫描')
				}
			},

			handleScanResult(commodityData) {
				if (!commodityData.isUse) {
					this.showError('商品不可用')
					return
				}

				if (this.isCase1(commodityData)) {
					this.handleCase1(commodityData)
				} else if (this.isCase2(commodityData)) {
					this.handleCase2(commodityData)
				} else {
					this.showError('不支持的商品类型')
				}
			},

			isCase1(commodityData) {
				return commodityData.isUse === true &&
					commodityData.isMultiMetering === false &&
					commodityData.commodityPriceTypeGroups.length === 1 &&
					commodityData.commodityPriceTypeGroups[0].commodityPriceTypes.length === 1
			},

			isCase2(commodityData) {
				return commodityData.isUse === true && (
					commodityData.isMultiMetering === true ||
					commodityData.commodityPriceTypeGroups.length > 1 ||
					(commodityData.commodityPriceTypeGroups.length === 1 &&
						commodityData.commodityPriceTypeGroups[0].commodityPriceTypes.length > 1)
				)
			},

			handleCase1(commodityData) {
				const exists = this.case1IsExist(commodityData)

				if (!exists) {
					this.addNewCommodity1(commodityData)
				} else {
					this.updateExistingCommodity(commodityData)
				}

				this.$emit('submitSelected', this.commoditySelected)
			},

			addNewCommodity1(commodityData) {
				const firstGroup = commodityData.commodityPriceTypeGroups[0]
				const firstPriceType = firstGroup.commodityPriceTypes[0]

				if (!firstPriceType) {
					this.showError('商品价格类型数据异常')
					return
				}
				// 传入负库存标识
				const step = this.calculateStep(commodityData.stock, 1, commodityData.negativeStock)

				this.commoditySelected.push({
					commodity: commodityData,
					data: [{
						priceType: `${firstGroup.groupName},${firstPriceType.priceType}`,
						quantity: step,
						imgFiles: commodityData.imgFile || [],
						sellByDate: [],
						unit: commodityData.unit || '',
						intoPrice: firstPriceType.intoPrice || 0,
						retailPrice: firstPriceType.retailPrice || 0,
						wholesalePricePrice: firstPriceType.wholesalePricePrice || 0
					}]
				})
			},

			addNewCommodity2(commodityPriceTypeData, commodityData) {
				if (!commodityPriceTypeData) {
					this.showError('商品价格类型数据异常')
					return
				}
				let stock = commodityPriceTypeData.commodityPriceTypeGroup.commodity.commodityInventorys
					.filter((m) => m.commodityPriceType == commodityPriceTypeData.priceType)
					.reduce((sum, m) => sum + m.stock, 0);
				// 传入负库存标识
				const step = this.calculateStep(stock, 1, commodityData.negativeStock)

				this.commoditySelected.push({
					commodity: commodityData,
					data: [{
						priceType: `${commodityPriceTypeData.commodityPriceTypeGroup.groupName},${commodityPriceTypeData.priceType}`,
						quantity: step,
						imgFiles: commodityPriceTypeData.commodityPriceTypeGroup.imgFiles || [],
						sellByDate: [],
						unit: commodityData.unit || '',
						intoPrice: commodityPriceTypeData.intoPrice || 0,
						retailPrice: commodityPriceTypeData.retailPrice || 0,
						wholesalePricePrice: commodityPriceTypeData.wholesalePricePrice || 0
					}]
				})
			},

			updateExistingCommodity(commodityData) {
				const firstGroup = commodityData.commodityPriceTypeGroups[0]
				const firstPriceType = firstGroup.commodityPriceTypes[0]
				const targetPriceType = `${firstGroup.groupName},${firstPriceType.priceType}`

				let updated = false

				for (const item of this.commoditySelected) {
					if (item.commodity.id === commodityData.id) {
						for (const dataItem of item.data) {
							if (dataItem.priceType === targetPriceType) {
								const newQuantity = dataItem.quantity + 1
								// 传入负库存标识
								dataItem.quantity = this.calculateStep(commodityData.stock, newQuantity, commodityData
									.negativeStock)
								updated = true
								break
							}
						}
						if (updated) break
					}
				}

				if (!updated) {
					this.addNewCommodity1(commodityData)
				}
			},

			calculateStep(stock, quantity, allowNegativeStock) {
				// 只有需要检查库存且不允许负库存时才限制数量
				if (this.shouldLimitMaxQuantity(allowNegativeStock)) {
					return Math.min(quantity, stock || 0);
				}
				return quantity;
			},

			handleCase2(commodityData) {
				this.initCurrentCommodityData(commodityData)
				this.$nextTick(() => {
					this.tableKey += 1;
					this.selectedSKU = true;
				})
			},

			showError(message) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: message
				});
			},
			formatCommodityTypeData(commodity) {
				const data = []
				commodity.commodityPriceTypeGroups.forEach(group => {
					group.commodityPriceTypes.forEach(priceType => {
						data.push({
							priceType: `${group.groupName},${priceType.priceType}`,
							quantity: 0,
							imgFiles: priceType.imgFiles || [],
							sellByDate: [],
							unit: commodity.unit || '',
							intoPrice: priceType.intoPrice || 0,
							retailPrice: priceType.retailPrice || 0,
							wholesalePricePrice: priceType.wholesalePricePrice || 0
						})
					})
				})
				return data
			},
			initCurrentCommodityData(commodityData) {
				this.currentCommodity.commodity = {
					...this.getDefaultCommodity(),
					...commodityData
				}

				if (this.isMultipleLines) {
					this.currentCommodity.data = this.formatCommodityTypeData(commodityData)
				} else {
					const existingIndex = this.commoditySelected.findIndex(
						item => item.commodity.id === commodityData.id
					)

					if (existingIndex > -1) {
						this.mergeCommodityData(existingIndex, commodityData)
					} else {
						this.currentCommodity.data = this.formatCommodityTypeData(commodityData)
					}
				}
			},
			mergeCommodityData(existingIndex, commodityData) {
				this.currentCommodity.data = this.formatCommodityTypeData(commodityData)

				const existingData = this.commoditySelected[existingIndex].data
				existingData.forEach(existingItem => {
					const targetIndex = this.currentCommodity.data.findIndex(
						newItem => newItem.priceType === existingItem.priceType
					)
					if (targetIndex > -1) {
						this.currentCommodity.data[targetIndex] = {
							...existingItem
						}
					}
				})

				if (existingData.length > 0) {
					this.currentCommodity.commodity.unit = existingData[0].unit
				}
			},
			// 提取价格类型查找逻辑
			findPriceType(commodity, priceTypeItems) {
				const [groupName, priceTypeName] = priceTypeItems;

				const targetGroup = commodity.commodityPriceTypeGroups.find(
					group => group.groupName === groupName
				);

				if (!targetGroup) return null;

				return targetGroup.commodityPriceTypes.find(
					priceType => priceType.priceType === priceTypeName
				) || null;
			},

			getCommodityTypeStockByCurrent(priceType) {
				const {
					commodity
				} = this.currentCommodity
				if (!commodity.commodityInventorys.length) return 0

				const stock = commodity.commodityInventorys
					.filter(inv => inv.commodityPriceType === priceType)
					.reduce((sum, inv) => sum + (inv.stock || 0), 0)

				const adjustedStock = this.getCurrentUseUnit.conversionRate ?
					stock * this.getCurrentUseUnit.conversionRate : stock

				return adjustedStock > 0 && Number.isFinite(adjustedStock) ?
					formatNum(adjustedStock) : 0
			},
			cleanupEmptyCommodities() {
				// 过滤掉数量为0的数据项
				this.commoditySelected.forEach(commodity => {
					commodity.data = commodity.data.filter(dataItem =>
						dataItem.quantity > 0
					)
				})

				// 过滤掉没有数据项的商品
				for (let i = this.commoditySelected.length - 1; i >= 0; i--) {
					if (this.commoditySelected[i].data.length === 0) {
						this.commoditySelected.splice(i, 1)
					}
				}
			},
			/**
			 * 预览SKU图片 - 简化版本，使用子组件
			 */
			previewSkuImages(images) {
				if (!images || images.length === 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "暂无图片"
					});
					return;
				}

				this.previewImagesList = images;
				this.currentImageIndex = 0;
				this.previewVisible = true;
			},
			/**
			 * 图片切换事件
			 */
			onPreviewImageChange(index, image) {
				this.currentImageIndex = index;
			},
			getCurrentCommodityTypeMaxStock(data) {
				if (!this.currentCommodity.commodity.commodityInventorys) return 0;
				let stock = 0;
				this.currentCommodity.commodity.commodityInventorys.forEach(item => {
					if (item.commodityPriceType == data.priceType) {
						stock += item.stock;
					}
				})
				if (this.isMultipleLines) {
					// 减去已选数量
					for (let i = 0; i < this.commoditySelected.length; i++) {
						if (this.currentCommodity.commodity.id == this.commoditySelected[i].commodity.id) {
							this.commoditySelected[i].data.forEach(item => {
								if (item.priceType == data.priceType) {
									this.commoditySelected[i].commodity.extraUnits.forEach(item2 => {
										if (item.unit == item2.unit) {
											stock -= item.quantity / item2.conversionRate;
										}
									});
								}
							});
						}
					}
				}

				let unitData = this.getUnitData(data.unit);
				if (unitData) {
					stock = unitData.conversionRate * stock;
				}
				return formatNum(stock);
			},
			getUnitData(unitName) {
				if (this.currentCommodity.commodity.extraUnits) {
					let unit = this.currentCommodity.commodity.extraUnits.find(m => m.unit == unitName);
					if (unit) {
						return unit;
					}
				}
				return null;
			},
			/**
			 * 判断是否需要检查库存（是否限制数量）
			 * 只有采购退货单(type='1')、零售单和销售单(type='2')需要检查库存
			 */
			needCheckStock() {
				return this.type === '1' || this.type === '2';
			},

			/**
			 * 判断是否应该限制数量最大值
			 */
			shouldLimitMaxQuantity(allowNegativeStock) {
				return this.needCheckStock() && !allowNegativeStock;
			},

			/**
			 * 获取数量输入框的最大值
			 */
			getMaxQuantity(stock, allowNegativeStock) {
				if (this.shouldLimitMaxQuantity(allowNegativeStock)) {
					return stock;
				}
				return 99999999999;
			},

			/**
			 * 计算调整后的数量（考虑负库存限制）
			 */
			adjustQuantity(value, stock, allowNegativeStock) {
				let step = value;
				if (step < 0) {
					step = 0;
				}
				if (this.shouldLimitMaxQuantity(allowNegativeStock)) {
					step = stock > step ? step : stock;
				}
				return step;
			},
		}
	}
</script>

<style scoped>
	.modal-content {
		min-height: 500px;
	}

	#page-box {
		margin-top: 15px;
		text-align: center;
	}

	.selected-goods {
		float: left;
		height: 52px;
		line-height: 52px;
		text-align: center;
		width: auto;
		padding: 0px 10px;
		color: #fff;
		background-color: rgb(255, 106, 127);
		font-size: 15px;
		cursor: pointer;
		font-weight: bold;
		border-radius: 0px 0px 0px 6px;
	}

	/deep/ .ivu-modal-footer {
		padding: 0px !important;
		background-color: rgba(255, 255, 255, 0) !important;
	}

	.selected-sku {
		float: left;
		height: 32px;
		line-height: 32px;
		text-align: center;
		width: auto;
		padding: 0px 10px;
		color: rgb(255, 106, 127);
		font-size: 18px;
		cursor: pointer;
		font-weight: bold;
		border-radius: 0px 0px 0px 6px;
	}

	.footer-tool {
		padding: 10px;
	}

	/deep/ .ivu-badge-count {
		top: -3px;
	}

	/deep/ .ivu-modal-content {
		background-color: white;
	}

	/deep/ .ivu-modal-body {
		padding: 0px;
	}

	#box-search {
		margin-bottom: 15px;
		overflow: hidden;
	}

	.search_input {
		width: 200px;
		margin-right: 15px;
	}

	.box-search-left {
		float: left;
	}

	.box-search-right {
		float: right;
	}

	.modal-header {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		overflow: hidden;
		color: rgb(255, 106, 127);
	}

	/* 抽屉内容区域样式 */
	.drawer-content {
		padding: 10px;
		height: 100%
	}

	.drawer-content-item {}

	.drawer-content-item+.drawer-content-item {
		border-top: 1px solid #e8e8e8;
		padding-top: 10px;
		margin-top: 10px;
	}

	.drawer-content-item /deep/ div {
		border: none !important;
	}

	.content-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
		flex: 1;
		text-align: right;
		margin: 0px 15px;
	}
</style>